<template lang='pug'>
  .product-show
    keep-alive
      ProductShowReordered(v-if='isMobile')
      ProductShow(v-else)
</template>

<script>
export default {
  name: 'ProductsShow',

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setPreviousPath(from)
    })
  },

  beforeRouteUpdate (to, from, next) {
    this.setPreviousPath(from)
    next()
  },

  components: {
    ProductShow: () => import('./show/main.vue'),
    ProductShowReordered: () => import('./show-reordered-optimized-pdp/main.vue')
  },

  computed: {
    isMobile: () => vueSupport.isMobile
  },

  methods: {
    setPreviousPath (from) {
      const previousPath = from.fullPath !== '/'
        ? from.fullPath
        : (document.referrer ? new URL(document.referrer).pathname : '')

      this.$store.commit('setPreviousPath', previousPath)
    }
  }
}
</script>
